var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator"},[_vm._v(_vm._s(("Ver: " + _vm.latestVersion + " - SHA: " + _vm.latestCommit)))])}
var staticRenderFns = []

export { render, staticRenderFns }